export default __webpack_public_path__ + "static/media/picture.bcf137be.svg";